














































// Vue
import { defineComponent, PropType } from '@vue/composition-api'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'
import { Button, Icon } from '@/components/general'

// Models
import { Paginator } from '@/models'
import { BondControl } from '@/models/dailyControl'

// constants
import { getTypeText } from '@/constants/discountTypeConstants'

export default defineComponent({
  name: 'DiscountConrolTableList',
  components: {
    DataTable,
    IsActive,
    Button,
    Icon
  },
  props: {
    items: {
      type: Array as PropType<BondControl[]>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object as PropType<Paginator>,
      default: () => ({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
      })
    },
    changePage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    },
    changePerPage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    }
  },
  setup () {
    const fields = [
      {
        key: 'date',
        sortable: true,
        label: 'Fecha'
      },
      {
        key: 'employee.fullName',
        sortable: true,
        label: 'Empleado'
      },
      {
        key: 'discountType.name',
        sortable: true,
        label: 'Tipo de Descuento'
      },
      {
        key: 'frequency_text',
        sortable: true,
        label: 'Frecuencia'
      },
      {
        key: 'type',
        sortable: true,
        label: 'Tipo de Cálculo'
      },
      {
        key: 'amount_text',
        sortable: true,
        label: 'Importe'
      },
      {
        key: 'observations',
        sortable: true,
        label: 'Observaciones'
      },
      {
        key: 'actions',
        sortable: false,
        label: '',
        thClass: 'one-line w-30',
        thStyle: {
          width: '10%'
        }
      }
    ]
    return {
      fields,
      getTypeText
    }
  }
})
